define('AAMedical.ScopeRepair.ServiceYourScope.View'
,	[
		'aamedical_scoperepair_serviceyourscope.tpl',
		'Backbone',
		'Backbone.FormView',
		'AAMedical.ScopeRepair.ServiceYourScope.Model',
		'Utils',
		'GlobalViews.Message.View'
	]
,	function (
		aamedical_scoperepair_serviceyourscope_tpl,
		Backbone,
		BackboneFormView,
		ServiceYourScopeModel,
		Utils,
		GlobalViewsMessageView
	)
{
	'use strict';

	return Backbone.View.extend({

		template: aamedical_scoperepair_serviceyourscope_tpl,

		title: Utils.translate('Service Your Scope'),

		page_header: Utils.translate('Service Your Scope'),

		attributes: {
			id: 'service-your-scope',
			class: 'service-your-scope-page'
		},

		events: {
			'submit form': 'submitForm'
		},

		bindings: {
			'[name="firstname"]': 'firstname',
			'[name="lastname"]': 'lastname',
			'[name="businessname"]': 'businessname',
			'[name="address"]': 'address',
			'[name="city"]': 'city',
			'[name="state"]': 'state',
			'[name="zipcode"]': 'zipcode',
			'[name="email"]': 'email',
			'[name="phone"]': 'phone',
			'[name="manufacturer"]': 'manufacturer',
			'[name="model"]': 'model',
			'[name="concerns"]': 'concerns'
		},

		initialize: function(options) {
			this.options = options;
			this.application = options.application;
			this.model = new ServiceYourScopeModel();
			BackboneFormView.add(this);
		},

		getBreadcrumbPages: function() {
			return [{ href: '/service-your-scope', text: Utils.translate('Get a Quote') }];
		},

		submitForm: function(e, model, props) {
			e.preventDefault();

			var self = this;

			if (typeof grecaptcha === 'undefined') {
				self.showErrorMessage('reCAPTCHA failed to load. Please refresh and try again.');
				return;
			}

			grecaptcha.ready(function() {
				grecaptcha.execute('6Ldm7swpAAAAAAvJ-a9wVCmWcuSIGrVogtSXESPD', { action: 'scope_repair' }).then(function(token) {
					self.$('#recaptcha_token').val(token);
					self.model.set('recaptcha_token', token);

					var promise = self.saveForm(e, model, props);

					if (promise) {
						promise.done(function() {
							self.showSuccessMessage();
						});

						promise.fail(function(jqXhr) {
							var message = 'An error occurred. Please try again.';
							if (jqXhr && jqXhr.responseJSON && jqXhr.responseJSON.errorMessage) {
								message = jqXhr.responseJSON.errorMessage;
							}
							self.showErrorMessage(message);
						});
					}
				});
			});
		},

		showSuccessMessage: function() {
			this.$('form')[0].reset();
			this.$('[data-validation-error]').removeAttr('data-validation-error');
			this.$('.error').removeClass('error');
			this.$('[data-type="alert-placeholder"]').empty();

			this.model = new ServiceYourScopeModel();
			BackboneFormView.add(this);

			this.$('[data-type="success-placeholder"]').html(
				'<div class="alert alert-success" style="color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6;padding:15px;margin-top:20px;border-radius:4px;">' +
				'Thank you! Your service request has been submitted. We will be in touch shortly.' +
				'</div>'
			);

			this.$('html, body').animate({ scrollTop: this.$('[data-type="success-placeholder"]').offset().top - 100 }, 400);

			var self = this;
			setTimeout(function() {
				self.$('[data-type="success-placeholder"]').fadeOut(500, function() {
					jQuery(this).empty().show();
				});
			}, 120000);
		},

		showErrorMessage: function(message) {
			this.$('[data-type="alert-placeholder"]').html(
				new GlobalViewsMessageView({
					message: message,
					type: 'error',
					closable: true
				}).render().$el.html()
			);
		},

		getContext: function() {
			return {};
		}
	});
});
